import { FC } from 'react';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { Button } from './buttons.styles';
import { ButtonProps } from './buttons.types';

export const PrevButton: FC<ButtonProps> = ({ disabled, onClick }) => (
  <Button disabled={disabled} onClick={onClick}>
    <ArrowLeftIcon />
  </Button>
);

export const NextButton: FC<ButtonProps> = ({ disabled, onClick }) => (
  <Button disabled={disabled} onClick={onClick}>
    <ArrowRightIcon />
  </Button>
);
